/**
 * dropdown-expanded.js
 *
 * Reports open/closed state on the theme's dropdown triggers (SBMR-85).
 *
 * The sort, layout, currency and language controls are real <button>s driven by
 * theme.min.js, which marks the open trigger with the "is--clicked" class but
 * never sets aria-expanded, so screen readers cannot tell the state. Mirroring
 * that class is the only hook available without editing the minified bundle.
 *
 * Applied to every [data-dropdown-open][data-id] rather than just the sort
 * control, since all 11 triggers share the same component and the same gap.
 */
(function () {
  'use strict';

  var TRIGGER = '[data-dropdown-open][data-id]';
  var OPEN_CLASS = 'is--clicked';

  function wire(btn) {
    if (btn.dataset.expandedWired === 'true') return;
    btn.dataset.expandedWired = 'true';

    // Only claim to control a panel that actually exists.
    var id = btn.getAttribute('data-id');
    if (id && document.getElementById(id) && !btn.hasAttribute('aria-controls')) {
      btn.setAttribute('aria-controls', id);
    }
    if (!btn.hasAttribute('aria-haspopup')) btn.setAttribute('aria-haspopup', 'listbox');

    function sync() {
      btn.setAttribute('aria-expanded', btn.classList.contains(OPEN_CLASS) ? 'true' : 'false');
    }

    new MutationObserver(sync).observe(btn, {
      attributes: true,
      attributeFilter: ['class']
    });

    sync();
  }

  function init() {
    var all = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < all.length; i++) wire(all[i]);
  }

  // Collection grids re-render on filter and pagination, so pick up new triggers.
  function watch() {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () { scheduled = false; init(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() { init(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
